import { InfoCircleIcon } from "./icons";

const Tooltip = ({ tip }) => (
  <span tabIndex={0} title={tip}>
    <InfoCircleIcon />
  </span>
);

export default Tooltip;
